import { Star } from "lucide-react";

import binanceLogo from "@/assets/checkout/logo-binance.svg";
import bumbleLogo from "@/assets/checkout/logo-bumble.svg";
import digitalMarketerLogo from "@/assets/checkout/logo-digitalmarketer.svg";
import proofLogo from "@/assets/checkout/logo-proof.svg";
import vitaCupLogo from "@/assets/checkout/logo-vitacup.svg";
import testimonialPhoto from "@/assets/checkout/testimonial-georgina.png";

const BRAND_LOGOS = [
  { alt: "bumble", src: bumbleLogo },
  { alt: "VitaCup", src: vitaCupLogo },
  { alt: "DigitalMarketer", src: digitalMarketerLogo },
  { alt: "Binance", src: binanceLogo },
  { alt: "PROOF", src: proofLogo },
];

export function CheckoutSocialProof() {
  return (
    <>
      <div className="flex flex-col gap-4 border-t border-border-secondary pt-5">
        <p className="text-[12px]/4 text-text-secondary leading-relaxed">
          &quot;We&apos;ve used NoLimit Creatives for the past 4 or 5 years now,
          and we&apos;ve never managed to find a freelancer or other provider
          who can match their skillset, speed and customer service. Would highly
          recommend them for digital agencies looking for creative
          support.&quot;
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <img
              alt="Georgina McGurk"
              className="size-9 rounded-full object-cover"
              src={testimonialPhoto}
            />
            <div className="flex flex-col gap-0.5">
              <span className="text-sm font-bold text-text-primary">
                Georgina McGurk
              </span>
              <span className="text-[12px]/4 text-text-tertiary">
                Head of Paid Social, Yatter
              </span>
            </div>
          </div>
          <div
            aria-label="5 out of 5 stars"
            className="flex gap-0.5"
            role="img"
          >
            {Array.from({ length: 5 }, (_, index) => (
              <span
                className="flex size-4 items-center justify-center rounded-[2px] bg-fg-primary"
                key={index}
              >
                <Star
                  aria-hidden
                  className="size-2.5 fill-current text-text-white"
                />
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-3 border-t border-border-secondary pt-5">
        <span className="text-xs font-medium text-text-tertiary">
          Trusted by the world&apos;s largest brands
        </span>
        <div className="flex items-center justify-between">
          {BRAND_LOGOS.map((logo) => (
            <img
              alt={logo.alt}
              className="w-[50px]"
              key={logo.alt}
              src={logo.src}
            />
          ))}
        </div>
      </div>
    </>
  );
}
